import { Type } from 'class-transformer';

export class AnnouncementsResultDto {
  announcementId: number;

  @Type(() => Date)
  releaseDate: Date;
  title: string;
  htmlContent: string;

  @Type(() => Date)
  expires: Date;
  createdBy: string;

  @Type(() => Date)
  createdOn: Date;

  context: string;
}
